import script from "./UiDatepicker.vue?vue&type=script&setup=true&lang=js"
export * from "./UiDatepicker.vue?vue&type=script&setup=true&lang=js"

import "./UiDatepicker.vue?vue&type=style&index=0&id=66d6c457&lang=scss"

const __exports__ = script;

export default __exports__